import type { datadogRum } from '@datadog/browser-rum';
import type { RealtimeRole } from '@doxyme/realtime';

export enum CustomDatadogContextKeys {
  Role = 'role',
  RoomSlug = 'roomSlug',
  RealtimeIdentityId = 'realtimeIdentityId',
}

export type CustomDatadogContextValueMap = {
  [CustomDatadogContextKeys.Role]: RealtimeRole;
  [CustomDatadogContextKeys.RoomSlug]: string;
  [CustomDatadogContextKeys.RealtimeIdentityId]: string;
};

export type CustomDatadogContext = Partial<CustomDatadogContextValueMap>;

export type DataDogUser = Parameters<typeof datadogRum.setUser>[0];
